function formatCityName(value?: string | null): string | null {
  if (!value) {
    return null;
  }
  const formattedString = value.charAt(0) + value.toLocaleLowerCase().slice(1);
  return formattedString;
}

export default formatCityName;
